import { render, staticRenderFns } from "./RpmClassificationDetail.vue?vue&type=template&id=39b54560"
import script from "./RpmClassificationDetail.vue?vue&type=script&lang=js"
export * from "./RpmClassificationDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports